import React from 'react'

const NxtWatchContext = React.createContext({
  darkMode: false,
  bannerStatus: true,
  savedVideosList: [],
  onClickSave: () => {},
  toggleTheme: () => {},
  closeBanner: () => {},
})

export default NxtWatchContext
